import Slices from "./slices";
export default Slices;
